module.exports = __webpack_public_path__ + "img/paishui (1).f07c9d82.png";